// extracted by mini-css-extract-plugin
export default {"departments":"QE-z","departmentHeading":"RE-z","departmentSection":"SE-z","departmentName":"TE-z","departmentLink":"UE-z","expandIcon":"VE-z"};